import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export const useQueryParams = (name?: string) => {
  const { search } = useLocation();

  return useMemo(() => {
    const queryParams = new URLSearchParams(search);

    if (name) {
      return queryParams.get(name);
    }
    return queryParams;
  }, [search, name]);
};
